import { Portal as Portal$1 } from './Portal.js';
export { registerPortalRoot } from './Portal.js';
var Portal = Portal$1;
export { Portal as default };